export const DEFAULT_TITLE = 'Numerator Question Library';
export const SCREENER_BLANK_VALUE = '(blank)';
export const SCREENER_PROMPT_TOKEN_REGEX = /{{\s*([a-zA-Z0-9_]+)\s*}}/g;

// Keys mirror the snake_case `{{token}}` placeholders stored in screener question and answer text.
export const HIERARCHY_PROMPT_CONFIG = {
  category_hierarchy: { label: 'Category', property: 'categoryHierarchy' },
  product_hierarchy: { label: 'Product', property: 'productHierarchy' },
  store_hierarchy: { label: 'Store', property: 'storeHierarchy' },
} as const;
